import type { RouteRecordRaw } from 'vue-router';

import { visionHubAccessGuard } from '@/app/visionHub/utils/route-guards';

export default {
  path: '/vision',
  component: () => import('@/app/visionHub/App.vue'),
  beforeEnter: visionHubAccessGuard,
  meta: {
    requiresAuth: true,
    hideVisionAi: true,
    fillHeight: true,
  },
  children: [
    {
      name: 'vision.landing',
      path: '',
      component: () => import('@/app/visionHub/pages/LandingPage.vue'),
      meta: {
        analytics: 'Vision - New Chat',
      },
    },
    {
      name: 'vision.chat',
      path: 'chat/:conversationId',
      component: () =>
        import('@/components/VisionAi/chat-panel-components/VisionChatSidePanel.vue'),
      props: { page: true },
      meta: {
        analytics: 'Vision - Chat',
      },
    },
  ],
} satisfies RouteRecordRaw;
